import axios from 'axios';
import {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

import AccessoryCheckbox from '-/components/general/AccessoryCheckbox';
import {get, partition} from '-/util/lodash';

class AccessoryMultiSelect extends Component {
    static propTypes = {
        handleCheckboxToggle: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            accessories: []
        };
    }

    componentDidMount = async() => {
        this._isMounted = true;

        const accessories = await this.getAccessories() || [];

        if (this._isMounted) {
            this.setState({accessories});
        }
    };

    componentWillReceiveProps = async nextProps => {
        const {ucgVehicleId} = this.props;
        const {ucgVehicleId: nextUcgVehicleId} = nextProps;

        if (nextUcgVehicleId && nextUcgVehicleId !== ucgVehicleId) {
            const accessories = await this.getAccessories(nextUcgVehicleId) || [];
            this.setState({accessories});
        }
    };

    getAccessories = async(nextUcgVehicleId = '') => {
        const {ucgVehicleId: ucgVehicleIdProp, vin = ''} = this.props;
        const ucgVehicleId = nextUcgVehicleId || ucgVehicleIdProp;
        let options = [];

        if (ucgVehicleId) {
            const res = await axios.get(`/api/refi/nada/getAccessories/${ucgVehicleId}/${vin}`);
            const {error} = res;

            if (error) {
                throw new Error(`Error getting accessories from NADA for ucgVehicleId ${ucgVehicleId}`);
            }

            const accessories = get(res, 'data', []);
            options = accessories;
        }

        return options;
    };

    toggleCheckbox = ({desc, code, retail}) => {
        const {accessoriesSelected = [], handleCheckboxToggle} = this.props;

        const accessory = {
            code,
            desc,
            retail
        };

        const checkedIndex = accessoriesSelected.findIndex(acc => acc.code === code);

        if (checkedIndex !== -1) {
            accessoriesSelected.splice(checkedIndex, 1);
        } else {
            accessoriesSelected.push(accessory);
        }
        handleCheckboxToggle(accessoriesSelected);
    };

    render() {
        const {accessories = []} = this.state;
        const {accessoriesSelected = [], ucgVehicleId} = this.props;
        let includedAccessories = [], unincludedAccessories = [];

        if (accessories.length > 0) {
            [includedAccessories = [], unincludedAccessories = []] = partition(accessories, 'isIncluded');
        }
        const showUnincludedAccessories = ucgVehicleId && unincludedAccessories && unincludedAccessories.length > 0;
        const showIncludedAccessories = ucgVehicleId && includedAccessories && includedAccessories.length > 0;

        return (
            <div className="info accessories">
                {(!showUnincludedAccessories && !showIncludedAccessories) && (
                    <p><b>No accessories found for this vehicle description</b></p>
                )}
                {showUnincludedAccessories && (
                    <Fragment>
                        <h3 className="info vin">Accessories</h3>
                        {unincludedAccessories.map((accessory, i) => {
                            const {desc, code, retail} = accessory;
                            const accessoryChecked = accessoriesSelected.findIndex(acc => acc.code === code);
                            return (
                                <AccessoryCheckbox
                                    key={`${code}-${desc}-${i}`}
                                    desc={desc}
                                    code={code}
                                    retail={retail}
                                    checked={accessoryChecked !== -1}
                                    handleCheckboxChange={this.toggleCheckbox} />
                            );
                        })}
                    </Fragment>
                )}
                {showIncludedAccessories && (
                    <div style={{clear: 'both'}}>
                        <h3 className="info vin">Included Accessories</h3>
                        {includedAccessories.map((acc, i) => {
                            const {desc, code, retail} = acc;
                            return (
                                <AccessoryCheckbox
                                    code={code}
                                    checked="checked"
                                    desc={desc}
                                    disabled="disabled"
                                    key={`${code}-${desc}-${i}`}
                                    retail={retail}
                                    handleCheckboxChange={() => {}} />
                            );
                        })}
                    </div>
                )}
            </div>
        );
    }
}

export default AccessoryMultiSelect;
